import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

export class CreditRedemptionStore extends Store {
  @observable public airCreditIntent = false;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setAirCreditIntent(airCreditIntent: boolean) {
    this.airCreditIntent = airCreditIntent;
  }
}

CreditRedemptionStore.DEFAULTS = {
  airCreditIntent: false
};
